import React, { useState } from 'react'
import { ICONS } from '@Const/common'
import Button from '@Components/Buttons/Button'
import './index.scss'
import clsx from 'clsx'
import { TableRowData } from '@Components/ViewWork/Table'

interface TableRowProps {
    className?: string
    tableRow: TableRowData
    removableCells?: boolean
    onRemoveCellClicked?: (removeCellIdentifier?: string) => void
    defaultExpanded?: boolean
    onExpandCellClicked?: (expanded: boolean) => void
}

const TableRow = ({
    className,
    tableRow,
    removableCells,
    onRemoveCellClicked,
    onExpandCellClicked,
    defaultExpanded = false,
}: TableRowProps) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded)

    return (
        <div className={clsx('table-row', className)}>
            {tableRow.subTables && (
                <div
                    className="expand-table-cell table-cell"
                    onClick={() => {
                        const expanded = !isExpanded
                        setIsExpanded(expanded)
                        onExpandCellClicked && onExpandCellClicked(expanded)
                    }}
                >
                    <img src={isExpanded ? ICONS.chevron_drop_up : ICONS.chevron_drop_down} alt="expand-cell-toggle" />
                </div>
            )}

            {tableRow.cells.map((cell, index) => (
                <div className="table-cell" key={`row-${index}`}>
                    {cell}
                </div>
            ))}

            {tableRow.cells.length > 0 && removableCells && (
                <div className="remove-cell table-cell" data-testid="remove-cell">
                    <Button
                        disabled={!tableRow.removable}
                        mainColor
                        type="tertiary"
                        icon={ICONS.trashCan}
                        onClick={() => {
                            onRemoveCellClicked && onRemoveCellClicked(tableRow.removeCellIdentifier)
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default TableRow
